import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export default function Dashboard() {
  const [expandedModule, setExpandedModule] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState("1-1");

  const modules = [
    { 
      id: 1, 
      name: "Fundamentos del Trading",
      units: [
        { id: 1, name: "Introducción a los Mercados", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_1" },
        { id: 2, name: "Conceptos Básicos", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_2" },
        { id: 3, name: "Primeros Pasos", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_3" }
      ]
    },
    { 
      id: 2, 
      name: "Análisis Técnico",
      units: [
        { id: 1, name: "Gráficos y Velas", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_4" },
        { id: 2, name: "Soportes y Resistencias", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_5" },
        { id: 3, name: "Indicadores Técnicos", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_6" }
      ]
    },
    { 
      id: 3, 
      name: "Estrategias de Trading",
      units: [
        { id: 1, name: "Estrategias Básicas", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_7" },
        { id: 2, name: "Gestión de Posiciones", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_8" },
        { id: 3, name: "Plan de Trading", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_9" }
      ]
    },
    { 
      id: 4, 
      name: "Psicología del Trader",
      units: [
        { id: 1, name: "Control Emocional", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_10" },
        { id: 2, name: "Disciplina en Trading", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_11" },
        { id: 3, name: "Mentalidad Ganadora", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_12" }
      ]
    },
    { 
      id: 5, 
      name: "Análisis Fundamental",
      units: [
        { id: 1, name: "Económia y Mercados", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_13" },
        { id: 2, name: "Análisis de Empresas", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_14" },
        { id: 3, name: "Noticias Financieras", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_15" }
      ]
    },
    { 
      id: 6, 
      name: "Herramientas Avanzadas",
      units: [
        { id: 1, name: "Plataformas de Trading", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_16" },
        { id: 2, name: "Automatización", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_17" },
        { id: 3, name: "Casos de Éxito", videoUrl: "https://www.youtube.com/watch?v=VIDEO_ID_18" }
      ]
    }
  ];

  const videos = {
    "1-1": { title: "Fundamentos del Trading - Introducción a los Mercados", description: "Aprende cómo funcionan los mercados financieros y los conceptos fundamentales que todo trader debe conocer." },
    "1-2": { title: "Fundamentos del Trading - Conceptos Básicos", description: "Entiende los términos clave y los principios básicos del trading en el mercado." },
    "1-3": { title: "Fundamentos del Trading - Primeros Pasos", description: "Da tus primeros pasos en el trading con una guía práctica y sencilla." },
    "2-1": { title: "Análisis Técnico - Gráficos y Velas", description: "Domina la lectura de gráficos y entiende las formaciones de velas japonesas." },
    "2-2": { title: "Análisis Técnico - Soportes y Resistencias", description: "Identifica los niveles clave de soportes y resistencias en el mercado." },
    "2-3": { title: "Análisis Técnico - Indicadores Técnicos", description: "Aprende a usar los indicadores más populares para tomar decisiones." },
    "3-1": { title: "Estrategias de Trading - Estrategias Básicas", description: "Descubre las estrategias más efectivas para iniciar tu carrera en trading." },
    "3-2": { title: "Estrategias de Trading - Gestión de Posiciones", description: "Aprende cómo gestionar tus posiciones para maximizar ganancias y minimizar riesgos." },
    "3-3": { title: "Estrategias de Trading - Plan de Trading", description: "Crea tu propio plan de trading personalizado y disciplinado." },
    "4-1": { title: "Psicología del Trader - Control Emocional", description: "Domina tus emociones y mantén la calma bajo presión en los mercados." },
    "4-2": { title: "Psicología del Trader - Disciplina en Trading", description: "Desarrolla la disciplina necesaria para seguir tu plan de trading." },
    "4-3": { title: "Psicología del Trader - Mentalidad Ganadora", description: "Construye la mentalidad correcta para tener éxito a largo plazo." },
    "5-1": { title: "Análisis Fundamental - Economía y Mercados", description: "Entiende cómo funcionan la economía y los mercados globales." },
    "5-2": { title: "Análisis Fundamental - Análisis de Empresas", description: "Aprende a analizar empresas para tomar decisiones de inversión informadas." },
    "5-3": { title: "Análisis Fundamental - Noticias Financieras", description: "Mantente actualizado con las noticias financieras más importantes." },
    "6-1": { title: "Herramientas Avanzadas - Plataformas de Trading", description: "Conoce las mejores plataformas de trading y cómo utilizarlas eficientemente." },
    "6-2": { title: "Herramientas Avanzadas - Automatización", description: "Automatiza tus estrategias y deja que el robot haga el trabajo por ti." },
    "6-3": { title: "Herramientas Avanzadas - Casos de Éxito", description: "Inspírate con casos reales de traders que han tenido éxito en los mercados." },
  };

  const extractYouTubeId = (url) => {
    if (!url) return null;
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const getVideoUrl = (moduleId, unitId) => {
    const module = modules.find(m => m.id === moduleId);
    if (!module) return null;
    const unit = module.units.find(u => u.id === unitId);
    return unit ? unit.videoUrl : null;
  };

  const toggleModule = (moduleId) => {
    setExpandedModule(expandedModule === moduleId ? null : moduleId);
  };

  const handleUnitClick = (moduleId, unitId) => {
    setSelectedUnit(`${moduleId}-${unitId}`);
  };

  const currentVideo = videos[selectedUnit];
  const [moduleId, unitId] = selectedUnit.split('-').map(Number);
  const currentVideoUrl = getVideoUrl(moduleId, unitId);
  const youtubeVideoId = extractYouTubeId(currentVideoUrl);

  return (
    <div className="flex h-screen bg-gray-900">
      {/* Sidebar */}
      <div className="w-64 bg-gray-800 text-white overflow-y-auto shadow-lg">
        <div className="p-6 border-b border-gray-700">
          <h2 className="text-2xl font-bold">MENU</h2>
        </div>

        <nav className="p-4">
          {modules.map((module) => (
            <div key={module.id} className="mb-2">
              {/* Módulo */}
              <button
                onClick={() => toggleModule(module.id)}
                className="w-full flex items-center justify-between px-4 py-3 rounded-lg hover:bg-gray-700 transition-colors font-semibold text-left"
              >
                <span>{module.name}</span>
                <ChevronDown
                  size={20}
                  className={`transition-transform ${
                    expandedModule === module.id ? "rotate-180" : ""
                  }`}
                />
              </button>

              {/* Unidades */}
              {expandedModule === module.id && (
                <div className="mt-2 ml-4 space-y-2 border-l-2 border-blue-500">
                  {module.units.map((unit) => (
                    <button
                      key={unit.id}
                      onClick={() => handleUnitClick(module.id, unit.id)}
                      className={`w-full text-left px-4 py-2 rounded-lg transition-colors ${
                        selectedUnit === `${module.id}-${unit.id}`
                          ? "bg-blue-600 font-semibold"
                          : "text-gray-300 hover:bg-gray-700"
                      }`}
                    >
                      {unit.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <div className="bg-gray-800 text-white p-6 shadow-md">
          <h1 className="text-3xl font-bold">{currentVideo.title}</h1>
        </div>

        {/* Video and Description */}
        <div className="flex-1 overflow-y-auto p-8">
          <div className="max-w-4xl mx-auto">
            {/* Video Container */}
            <div className="mb-8 rounded-xl overflow-hidden shadow-2xl bg-black aspect-video">
              {youtubeVideoId ? (
                <iframe
                  width="100%"
                  height="100%"
                  src={`https://www.youtube.com/embed/${youtubeVideoId}`}
                  title={currentVideo.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900 flex items-center justify-center flex-col gap-4">
                  <div className="text-6xl">🎬</div>
                  <p className="text-gray-400 text-center px-4">
                    Sin video asignado
                  </p>
                  <p className="text-sm text-gray-500">
                    Por favor, agrega un enlace de YouTube válido
                  </p>
                </div>
              )}
            </div>

            {/* Description Box */}
            <div className="bg-gray-800 rounded-xl p-8 shadow-lg">
              <h2 className="text-2xl font-bold text-white mb-4">Descripción</h2>
              <p className="text-gray-300 leading-relaxed text-lg">
                {currentVideo.description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
